import pkg from './package.json';
import FilePicker from './src/view/index';

export { pkg as _package, FilePicker };
